import {NavigationEnd, Router} from '@angular/router';
import {Injectable} from '@angular/core';
import {Title} from '@angular/platform-browser';
import { Localization } from "../enums/localization";
import {TranslateService} from '@ngx-translate/core';
import {filter} from 'rxjs/operators';

@Injectable()
export class TitleService {

  private source: {regexp: string, title: string}[];
  public readonly Localization = Localization;

  constructor(private router: Router, private title: Title, private translate: TranslateService) {
    this.createSource();
  }

  private createSource() {
    this.source = [
      {regexp: '^\\/buildings', title: Localization.Buildings},
      {regexp: '^\\/contacts', title: Localization.Contacts},
      {regexp: '^\\/inspections', title: Localization.Inspections},
      {regexp: '^\\/roles', title: Localization.Roles},
      {regexp: '^\\/accounts', title: Localization.Account},
      {regexp: '^\\/devices', title: Localization.Devices},
      {regexp: '^\\/report-settings', title: Localization.ReportSettings},
      {regexp: '^\\/import-export', title: Localization.ImportExport},
      {regexp: '^\\/feedback', title: Localization.Feedback},
      {regexp: '^\\/business', title: Localization.Business},
      {regexp: '^\\/license', title: Localization.LicenseAgreement},
      {regexp: '^\\/license', title: Localization.LicenseAgreement},
      {regexp: '^\\/subscription', title: Localization.Subscription},
      {regexp: '^\\/payment', title: Localization.Payment},
      {regexp: '^\\/buildings\\/\\d*\\/', title: Localization.Building},
    ];
  }

  public init() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        for (const entry of this.source) {
          if (event.url.match(entry.regexp)) {
            this.translate.get([Localization.ChappsManager as string, entry.title]).subscribe(values => {
              this.title.setTitle(`${values[Localization.ChappsManager]} - ${values[entry.title]}`);
            });
          }
        }
      });
  }
}


